import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const EngagementContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  color: ${Tokens.ColorTextSecondary};
  font-size: 14px;
  min-width: 100px;
`

export const EngagementItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${Tokens.ColorTextSecondary};

  span {
    font-weight: 500;
  }
`

export const EngagementMetrics = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
`
